import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  dismiss() {
    if (this.hasMessageTarget) {
      this.messageTarget.classList.add("d-none")
    }
  }
}
